export const environment = {
  production: false,
  apiEndpoint: 'http://127.0.0.1:3000',
  sachApiEndpoint: 'http://localhost:3000/',
  oneLogApi: 'https://onelog.dev.packtpub.services/api',
  sachWebURL: 'https://sach.dev.packt.com',
  jsonServer: 'http://localhost:3000',
  oneLogUrl: 'https://onelog.dev.packtpub.services',
};
